import { routes } from "@/router"

export function getMenuList(obj = routes, to = '') {
	let navBar = [];
	obj.forEach(o => {
		if (o.meta && o.meta.isMenu) {
			navBar.push({
				menuName: o.meta.menuName || o.name,
				name: o.name,
				href: o.href,
				to: o.redirect ? o.redirect : (to && to !== o.path ? to + '/' : '') + o.path,
				menuId: o.meta.menuId || ''
			});
		}
		if(o.children && o.children.length){
			let cMenu = getMenuList(o.children, o.path);
			cMenu.length && navBar.push(...cMenu);
		}
	})
	return navBar;
}

export function getMenuLevel(route) {
	
}

function buildIds(node) {
	let { menuId = '' } = node.meta || {};
	let tempObj = []
	if(!menuId) return tempObj;
	let ids = menuId.split('_');
	let ids1 = ids.map(o => {
		return o.replace(/[^a-zA-Z]/ig, "");
	})
	ids = Array.from(new Set([ ...ids1,...ids]));
	if(ids.length === 2){
		return ids;
	}else{
		tempObj = ids.splice(0, 2);
		ids.forEach(o => {
			tempObj.push(tempObj[0] + '_' + o);
		})
	}
	return tempObj;
}

export function findByName(node) {
	let ids = buildIds(node);
	let tempObj = [];
	if(ids.length === 0) return tempObj;
	let level = node.meta.level;
	function loop(id, list = routes) {
		for (let i = 0, len = list.length; i < len; i++) {
			let { meta = {}, path = '', name = '' } = list[i];
			if (meta.menuId === id) {
				let menuName = meta.menuName || name;
				menuName && tempObj.push({
					menuName: menuName,
					to: (path.indexOf(':') !== -1) ? false : name,
				})
				break;
			}
			list[i].children && loop(id, list[i].children);
		}
	}
	ids.forEach(o => loop(o));
	tempObj[tempObj.length - 1].to = false;
	return tempObj;
}


export function findChildrenItem(node) {
	let tempObj = [];
	if(node.menuId === 'A') return tempObj;
	loop(node.menuId);
	function loop(id, list = routes) {
		for (let i = 0, len = list.length; i < len; i++) {
			let { meta = {}, path = '', name = '', href } = list[i];
			let { menuId = '', menuName = '', mode = 3, level = 3 } = meta;
			if (menuId.indexOf(id) > 0 && level === 2) {
				let menuName = meta.menuName || name;
				menuName && tempObj.push({
					menuName: menuName,
					href: href,
					path: (path.indexOf('/') === -1 ? (node.to + '/') : '') + path,
					name: (path.indexOf(':') !== -1) ? false : name,
					mode: mode
				})
			}
			list[i].children && loop(id, list[i].children);
		}
	}
	tempObj.sort(function(a,b){
		return a.mode - b.mode
	})
	return tempObj;
}